<sb-card>
  <div card-header>
    {{ 'lang.globals.contentShare' |translate }}
    @if (sharedContentShares()?.length > 1) {
      {{ currentPlaylist }}
    }
  </div>
  <div card-header-more class="d-flex">
    <div class="d-flex align-items-center">
      @if (sharedContentShares()?.length > 1) {
        <sb-icon (click)="e?.prev()" class="mx-1 cursor-pointer blue" icon="arrowLeftAlt">
        </sb-icon>
        {{ currentPlaylist }} {{ 'lang.globals.of' | translate }} {{ sharedContentShares()?.length }}
        <sb-icon (click)="e?.next()" class="mx-1 cursor-pointer blue" icon="arrowRightAlt">
        </sb-icon>
      }
    </div>
  </div>
  <div card-body>

    <ngb-carousel #e (slide)="currentPlaylist = $event.current" [activeId]="currentPlaylist" [interval]="-1" [keyboard]="false"
                  [showNavigationArrows]="false" [showNavigationIndicators]="false" [wrap]="true">
      @for (assignment of sharedContentShares(); track $index; let i = $index) {
        <ng-template id="{{i+1}}" ngbSlide>
          <div class="tw-grid tw-grid-cols-4 tw-gap-3">
            <div>
              <h3>
                Info
              </h3>
              <div class="tw-flex tw-flex-row">
                <div class="tw-flex tw-flex-col tw-justify-start">
                  <!--
                  <div class="m-3 d-flex" *ngIf="sharedPlaylist?.playlist?.schedule">
                    <sb-icon class="mr-2" icon="schedules"></sb-icon>
                    {{ 'lang.schedules.schedule'|translate }}:
                    {{ sharedPlaylist?.playlist?.schedule?.name }}
                  </div>
                  -->
                  <div class="tw-m-3 tw-flex" [class.tw-pointer-events-none]="isInDeviceContext()">
                    <a (click)="showScreensModal(assignment?.screens)">
                      <sb-icon class="mr-2" icon="screen"></sb-icon>
                      {{ 'lang.globals.screens'|translate }}:
                      {{ assignment?.screens?.length }}
                    </a>
                  </div>
                  <div class="tw-m-3 tw-flex">
                    <a (click)="showDateTimeRanges(assignment?.ranges)">
                      <sb-icon class="tw-mr-2" icon="calendar"></sb-icon>
                      {{ 'lang.globals.timeRanges'|translate }}:
                      {{ assignment?.ranges?.length }}
                    </a>
                  </div>
                </div>
              </div>
              <div class="tw-flex tw-mt-2 tw-flex-col tw-justify-start">
                @for (range of assignment?.ranges; track $index) {
                  <div
                    class="d-flex my-1 mx-3 border-dashed-bottom"
                    container="body"
                    [ngbTooltip]="util.calculateTimespanBetweenDates(range?.from, range?.till)"
                  >
                    {{ util.dateToDateTimeString(range?.from?.value) }}  -  {{ util.dateToDateTimeString(range?.till?.value) }}
                  </div>
                }
              </div>
            </div>
            <div class="tw-col-span-2">
              @let contentShare = assignment.contentShareAssignment.contentShare;
              @if (contentShare) {
                <sb-card>
                  <div card-header class="">{{ 'lang.globals.contentShare' | translate }}
                    : {{ contentShare?.name }}
                  </div>

                  <div card-body>
                    <div class="tw-grid tw-grid-cols-2 tw-gap-3">

                      <div class="">
                        <h4>{{ 'lang.globals.validity' | translate }}:&nbsp;</h4>
                        <sb-comp-validity-range-display [from]="contentShare.validFrom"
                                                        [till]="contentShare.validTill"></sb-comp-validity-range-display>
                      </div>
                      <div class="tw-flex tw-flex-col">
                        <h4>{{ 'lang.globals.filter' | translate }}:&nbsp;</h4>
                        <sb-comp-filter-overview class="tw-flex" hideClass="d-xxl" [timeCull]="contentShare?.timeCull"
                                                 [geoCull]="contentShare?.geoCull"
                                                 [stateSpaceCull]="contentShare?.stateSpaceCull" [playerCull]="contentShare?.playerCull">
                        </sb-comp-filter-overview>
                      </div>
                      <div class="tw-col-span-2">

                        <div class="tw-mb-4">
                          <h4 class="">{{ 'lang.globals.quotas'|translate }}</h4>
                        </div>
                        <div class="tw-flex tw-gap-1">
                          @for (quota of contentShare.quotas; track quota.id) {
                            <sb-comp-single-quota [quota]="quota" [width]="quota.share"></sb-comp-single-quota>
                          } @empty {
                            <i class="tw-font-light">
                              {{ 'lang.globals.noQuotas' | translate }}
                            </i>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </sb-card>
              } @else {
                {{ 'lang.globals.noData' | translate }}
              }

            </div>
            <sb-card>
              <div card-header class="">{{ 'lang.globals.competingClients' |translate }}</div>
              <div card-body>
                @for (client of assignment.contentShareAssignment.competingClients; track client.id) {
                  <div class="">{{ client.name }}</div>
                } @empty {
                  <i class="">{{ 'lang.globals.noCompetingClients' |translate }}</i>
                }
              </div>
            </sb-card>
          </div>
        </ng-template>
      } @empty {
        {{ 'lang.globals.noData' | translate }}
      }
    </ngb-carousel>
  </div>
</sb-card>
